import CarWash from "./CarWash";

export default CarWash;
